var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 7.33321C6.41675 4.80191 8.46878 2.74988 11.0001 2.74988C13.5314 2.74988 15.5834 4.80191 15.5834 7.33321V10.0832C15.5834 12.6145 13.5314 14.6665 11.0001 14.6665C8.46878 14.6665 6.41675 12.6145 6.41675 10.0832V7.33321Z",
    stroke: "#02BD6E",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 7.33325H15.5834",
    stroke: "#02BD6E",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 10.0833H15.5834",
    stroke: "#02BD6E",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.1665V10.0832C18.3334 14.1333 15.0502 17.4165 11.0001 17.4165C6.94999 17.4165 3.66675 14.1333 3.66675 10.0832V9.1665",
    stroke: "#02BD6E",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.4165V20.1665",
    stroke: "#02BD6E",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneActiveIcon);
export default __webpack_public_path__ + "static/media/microphoneActiveIcon.1247d01a950bf9cafaa26df1ded122ca.svg";
export { ForwardRef as ReactComponent };